export default {
  CODES ({ codes }) {
    return codes
  },
  DOCUMENTS ({ documents }) {
    return documents
  },
  KONTOART ({ kontoart }) {
    return kontoart
  },
  COUNTRIES ({ countries }) {
    return countries
  },
  PROJEKTABSCHLUSS_SELECTION ({ projektabschlussSelection }) {
    return projektabschlussSelection
  },
  DOCUMENTS_PROJEKTABSCHLUSS ({ documentsProjektabschluss }) {
    return documentsProjektabschluss
  }
}
